$('#navbar-menu')
    .find('a[href="' + window.location.href + '"]')
    .addClass('active')
    .parent()
    .addClass('active')
    .parent()
    .parent()
    .parent()
    .addClass('active');

window.updateKPICard = (el) => {
    const elementClicked = $(el);
    const mainCard = elementClicked.parent().parent().parent().parent().parent();
    const displayingText = mainCard.find('a.kpi-displaying');
    const displayingGrowth = mainCard.find('.kpi-percentage-growth');
    const displayingProgress = mainCard.find('.progress-bar');
    const displayingValue = mainCard.find('.kpi-value');
    const newNumber = rand(1,99);

    displayingValue.html(rand(1,99) + ',' + rand(10,50));
    elementClicked.parent().find('.active').removeClass('active');
    elementClicked.addClass('active');

    displayingText.html(elementClicked.html());
    displayingProgress.width(newNumber + '%');
    displayingGrowth.html(newNumber + '%');
}
